import React from 'react';
import cn from 'classnames';

import * as styles from './Container.module.scss';

export default function Container({ id, className, padding, children }) {
  return (
    <section
      id={id}
      className={cn(styles.container, padding && styles[`padding${padding}`], className)}
    >
      {children}
    </section>
  );
}
